












import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'

import YourAccountHelperComponents1MainPage from '../pages-type-1-your-account/service-for-your-account-helper-components/your-account-helper-components-1-main-page.vue'
import App4PageNotFound from '../../../html-components-type-1-basic/basic-type-1-app/app-4-page-not-found.vue'

const namespace = 'digitalCurrency'

@Component({
  components: {
    YourAccountHelperComponents1MainPage,
    App4PageNotFound
  }
})
class Account1 extends Vue {

  @State('serviceAccount') serviceAccount?: string

  @Action('getDigitalCurrencyAccountByUsername', { namespace }) getDigitalCurrencyAccountByUsername?: any

  accountId: string = ''

  show404Message: boolean = false

  @Watch('serviceAccount') async updateServiceAccount (serviceAccount: any) {
    if (!serviceAccount) {
      return
    }
    await this.initializeAccount()
  }

  @Watch('$route.params.accountUsername') async updateRouteValue () {
    await this.initializeAccount()
  }

  async mounted () {
    await this.initializeAccount()
  }

  async initializeAccount () {
    this.show404Message = false

    const accountUsername = this.$router.currentRoute.params.accountUsername

    const digitalCurrencyAccount = await this.getDigitalCurrencyAccountByUsername(accountUsername)

    if (!digitalCurrencyAccount || !digitalCurrencyAccount.accountId) {
      this.show404Message = true
      return
    }

    this.accountId = digitalCurrencyAccount.accountId
  }
}

export default Account1


